import React from 'react';
import ReaderTypeList from './components/ReaderTypeList';

const ReaderTypeListPage: React.FC = () => {
  // Title is set at the application level
  return <ReaderTypeList />;
};

export default ReaderTypeListPage;